import {
    ComposerAttributeNode,
    ComposerAttributeOptionNode,
    ComposerAttributeType,
    ComposerOptionActionNode
} from '../../../configurator-components/composer-editors/attributes/composerAttributesModels';
import { setActionSceneElementType } from './composerHelpers';

export const ValidationErrors = {
    ATTRIBUTE_CODE_NOT_UNIQUE: 'Attribute code must be unique',
    OPTION_CODE_NOT_UNIQUE: 'Option code must be unique',
    OPTION_NOT_FROM_PLATFORM: 'Option must be an option from the store!'
};

const AddValidationError = (error: (typeof ValidationErrors)[keyof typeof ValidationErrors] | string, map: Map<string, string>, value: any) => {
    return map.set(Object.keys(error)[0], `${error}: ${value}`);
};

export const LazyValidateAttributes = async (attributeList: ComposerAttributeNode[]): Promise<ComposerAttributeNode[]> => {
    return new Promise<ComposerAttributeNode[]>((resolve) => {
        Promise.all(
            attributeList.map(async (attr) => {
                if (attr.type !== ComposerAttributeType.Attribute) return;
                // attribute code unique
                const duplicatedCode = attributeList.filter((a) => a.code === attr.code && a.id !== attr.id);
                duplicatedCode.forEach((duplicate) => {
                    AddValidationError(ValidationErrors.ATTRIBUTE_CODE_NOT_UNIQUE, attr.brokenValues, duplicate.code);
                });
                // mark also the attribute as invalid
                if (duplicatedCode.length > 0) {
                    AddValidationError(ValidationErrors.ATTRIBUTE_CODE_NOT_UNIQUE, attr.brokenValues, attr.code);
                }

                attr.options = await LazyValidateOptions(attr, attr.options);
            })
        ).then(() => resolve(attributeList));
    });
};

export const LazyValidateOptions = async (
    attribute: ComposerAttributeNode,
    optionList: ComposerAttributeOptionNode[]
): Promise<ComposerAttributeOptionNode[]> => {
    return new Promise<ComposerAttributeOptionNode[]>((resolve) => {
        Promise.all(
            optionList.map(async (option) => {
                // option code unique
                const duplicatedCode = optionList.filter((o) => o.code === option.code && o.id !== option.id);
                duplicatedCode.forEach((duplicate) => {
                    AddValidationError(ValidationErrors.OPTION_CODE_NOT_UNIQUE, option.brokenValues, duplicate.code);
                });
                // mark also the option as invalid
                if (duplicatedCode.length > 0) {
                    AddValidationError(ValidationErrors.OPTION_CODE_NOT_UNIQUE, option.brokenValues, option.code);
                }
                // if attribute is platform aware and an option is platform aware
                // check if all options are all platform aware
                if (attribute.platformAttribute && option.platformAttribute) {
                    const notFromPlatform = optionList.filter((o) => !o.platformAttribute);
                    notFromPlatform.map((o) => {
                        AddValidationError(ValidationErrors.OPTION_NOT_FROM_PLATFORM, o.brokenValues, o.code);
                    });
                }

                option.actions = await LazyValidateActions(option.actions);
            })
        ).then(() => resolve(optionList));
    });
};

export const LazyValidateActions = async (actionList: ComposerOptionActionNode[]): Promise<ComposerOptionActionNode[]> => {
    return new Promise<ComposerOptionActionNode[]>((resolve) => {
        actionList.forEach((action) => {
            // fix wrong scene action types
            setActionSceneElementType(action);
        });
        resolve(actionList);
    });
};
